<template>
  <div>
    <PageTitle title="Amenties" />
    <ValidationObserver ref="createObserver" v-slot="{ validate }" class="px-6">
      <tr v-if="editAmenityId == null" class="mb-2 align-center">
        <th>
          <ValidationProvider
            v-slot="{ errors }"
            name="Name"
            rules="required|no_spaces_only"
          >
            <v-col cols="12" class="pl-0">
              <v-text-field
                dense
                outlined
                label="Name"
                v-model="newAmenity.name"
                :error-messages="errors"
                @blur="newAmenity.name = newAmenity.name.trim()"
              />
            </v-col>
          </ValidationProvider>
        </th>

        <th>
          <ValidationProvider
            v-slot="{ errors }"
            name="Code"
            rules="required|no_spaces_only"
          >
            <v-col cols="12" class="pl-0">
              <v-text-field
                dense
                outlined
                label="Code"
                v-model="newAmenity.code"
                :error-messages="errors"
                @blur="newAmenity.code = newAmenity.code.trim()"
              />
            </v-col>
          </ValidationProvider>
        </th>

        <th>
          <permission-control permissionName="Amenity Create">
            <v-btn
              small
              depressed
              class="text-white btn_blue btn_medium w-100"
              @click="SaveAmenity(validate)"
            >
              Create
            </v-btn>
          </permission-control>
        </th>
      </tr>
    </ValidationObserver>

    <v-container fluid class="lighten-12 content">
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-card class="lighten-12 card-content mb-2">
          <v-row class="ma-0 align-right">
            <TableFilters
              :filters="['status', 'search']"
              v-model="filter"
              :columns="columns"
            ></TableFilters>
            <ImportExportMenu :permission="'Amenity Report'"></ImportExportMenu>
          </v-row>
        </v-card>

        <LoadingComponent
          v-if="isLoading"
          :visible="isLoading"
        ></LoadingComponent>
        <v-card class="lighten-12 mt-2">
          <v-container fluid class="light gray lighten-12">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  :items-per-page="paginationOptions.perPage"
                  :fixed-header="true"
                  :headers="headers"
                  :items="Amenitys"
                  item-key="id"
                  hide-default-footer
                >
                  <!-- No -->
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>
                  <!-- Name -->
                  <template v-slot:item.name="{ item }"
                    ><ValidationProvider
                      v-slot="{ errors }"
                      name="Name"
                      vid="name"
                      v-if="item.id == editAmenityId"
                      rules="required|no_spaces_only"
                    >
                      <v-text-field
                        v-model="newAmenity.name"
                        :error-messages="errors"
                        :value="item.name"
                        outlined
                        class="pt-3"
                        @blur="newAmenity.name = newAmenity.name.trim()"
                      ></v-text-field>
                    </ValidationProvider>
                    <p v-else>{{ item.name }}</p>
                  </template>

                  <!-- Name -->
                  <template v-slot:item.code="{ item }">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Code"
                      v-if="item.id == editAmenityId"
                      vid="code"
                      rules="required|no_spaces_only"
                    >
                      <v-text-field
                        :error-messages="errors"
                        v-model="newAmenity.code"
                        :value="item.code"
                        outlined
                        class="pt-3"
                        @blur="newAmenity.code = newAmenity.code.trim()"
                      ></v-text-field>
                    </ValidationProvider>
                    <p v-else>{{ item.code }}</p>
                  </template>

                  <!-- Status -->
                  <template v-slot:item.status="{ item }" :slot-scope="props">
                    <toggle-button
                      v-model="newAmenity.is_active"
                      v-if="editAmenityId == item.id"
                      :disabled="editAmenityId != item.id"
                      :value="item.is_active"
                      :width="80"
                      :labels="{ checked: 'Active', unchecked: 'Archeived' }"
                    ></toggle-button>
                    <v-chip
                      v-else
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active ? "Active" : "Archived" }}</v-chip
                    >
                  </template>

                  <!-- Action -->
                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="scroll-y-transition">
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-show="editAmenityId != item.id"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-dots-vertical</v-icon
                        >
                        <v-btn
                          v-show="editAmenityId == item.id"
                          color="secondary"
                          fab
                          x-small
                          dark
                          class="ma-1"
                        >
                          <v-icon
                            depressed
                            small
                            link
                            @click="CancelAmenity(item)"
                            >clear</v-icon
                          ></v-btn
                        >
                        <v-btn
                          v-show="editAmenityId == item.id"
                          color="green"
                          fab
                          x-small
                          dark
                          ><v-icon link @click="UpdateAmenity(item)"
                            >done</v-icon
                          ></v-btn
                        >

                        <!-- {{editAmenityId==item.id}} -->
                      </template>

                      <v-list class="actions">
                        <permission-control permissionName="Amenity Edit">
                          <v-list-item link @click="EditAmenity(item)">
                            <span>
                              <v-icon v-bind="attrs" v-on="on"
                                >mdi-pencil-box-outline</v-icon
                              >Edit
                            </span>
                          </v-list-item>
                        </permission-control>
                        <permission-control
                          permissionName="Amenity Soft Delete"
                        >
                          <v-list-item link @click="openConfirmation(item)">
                            <span>
                              <v-icon v-bind="attrs" v-on="on">
                                {{
                                  item.is_active
                                    ? "mdi-archive"
                                    : "mdi-checkbox-marked-circle"
                                }}
                              </v-icon>
                              {{ item.is_active ? "Archieve" : "Active" }}
                            </span>
                          </v-list-item>
                        </permission-control>
                        <permission-control
                          permissionName="Amenity Soft Delete"
                        >
                          <v-list-item
                            link
                            dense
                            @click="onDeleteClickedItem(item)"
                          >
                            <span>
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-delete
                              </v-icon>
                              Delete
                            </span>
                          </v-list-item>
                        </permission-control>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="setResponseData"
                      url="hms/amenities"
                      :filter="filter"
                      ref="pagination"
                    >
                    </pagination>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </v-container>
        </v-card>
      </ValidationObserver>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import TableFilters from "@/components/base/TableFilters";

import { required, email, max, regex } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import pagination from "../../shared/components/pagination";
import confirmation from "../../shared/components/confirmation";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("no_spaces_only", {
  validate: (value) => {
    return value && value.trim().length > 0;
  },
  message: "{_field_} cannot be empty or spaces only",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("regex", {
  ...regex,
  message: "The value is not a valid phone number",
});
export default {
  components: {
    pagination,
    ValidationProvider,
    TableFilters,
    ValidationObserver,
  },
  data() {
    return {
      paginationOptions: {},
      isLoading: false,
      pagination1: {
        descending: true,
        page: 1,
        rowsPerPage: 2,
        sortBy: "fat",
        totalItems: 0,
        AmenityErrors: null,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      Amenitys: [],
      pagination: {
        page: 1,
        itemsPerPage: 2,
      },
      page: 1,
      status: [
        { text: "Active", value: "active" },
        { text: "Archived", value: "archived" },
      ],
      columns: [
        {
          text: "Name",
          value: "name",
          show: true,
          disabled: false,
          width: "35%",
          align: "left",
        },
        {
          text: "Code",
          value: "code",
          show: true,
          disabled: false,
          width: "35%",
          align: "left",
        },
        {
          text: "Status",
          value: "status",
          show: true,
          disabled: false,
          align: "center",
          width: "15%",
        },
        {
          text: "Actions",
          value: "action",
          show: true,
          disabled: false,
          align: "center",
          width: "15%",
        },
      ],
      newAmenity: { name: "", id: "", code: "", is_active: "" },
      filter: {
        code: "",
        name: "",
        search: "",
        status: "",
      },

      // For edit purpose
      editAmenityId: null,
    };
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(Amenity) {
      this.Amenitys = Amenity;
    },

    CancelAmenity(item) {
      this.refreshData();
      this.editAmenityId = null;
      this.newAmenity = {};
    },
    SaveAmenity() {
      const isValid = this.$refs.observer.validate();
      if (isValid) {
        this.newAmenity.name = this.newAmenity.name.trim();
        this.newAmenity.code = this.newAmenity.code.trim();
        this.isLoading = true;
        this.CreateAmenity();
      }
    },

    CreateAmenity() {
      let Amenityname = this.newAmenity;
      this.$store
        .dispatch("Amenity/CreateAmenity", Amenityname)
        .then((res) => {
          //this.succeeed = true;

          this.$toast.success("Amenity created  succesfully");
          this.refreshData();
          this.$refs.createObserver.reset();
          this.isLoading = false;
          this.newAmenity = {};
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error("Amenity created  failed");
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },

    onDeleteClickedItem(item) {
      confirmation.dialog = true;
      this.$confirm("Do you want to " + "Delete " + item.name + " ?").then(
        (res) => {
          if (res) {
            this.$store
              .dispatch("Amenity/DeleteAmenity", item.id)
              .then((res) => {
                this.refreshData();
                const msg = item.name + " deleted";
                this.$toast.success("Successfully  " + msg);
              })
              .catch((err) => {
                this.$toast.error(item.name + " is not deleted");
              });
          } else {
          }
        }
      );
    },

    UpdateAmenity(data) {
      let Amenity = _.cloneDeep(data);
      this.$store
        .dispatch("Amenity/EditAmenity", Amenity)
        .then((res) => {
          //
          //   this.newAmenity =[]

          this.editAmenityId = null;
          this.newAmenity = {};
          this.$toast.success("Amenity   edited  successfully");
          this.$refs.observer.reset();
          this.refreshData();
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.AmenityErrors = err.data.error.name;
          this.messages = err.data.title;
          this.$toast.error("Amenity edited failed");
        });
    },

    EditAmenity(data) {
      this.newAmenity = data;
      this.editAmenityId = data.id;
    },
    getStatusColor(is_active) {
      return is_active ? "green" : "gray";
    },
    openConfirmation(Amenity) {
      confirmation.dialog = true;
      this.$confirm(
        "Do you want to " +
          (Amenity.is_active ? "Archive " : "Active ") +
          Amenity.name +
          " ?"
      ).then((res) => {
        if (res) {
          this.$store
            .dispatch("Amenity/ActiveOrArchiveAmenity", Amenity.id)
            .then((res) => {
              this.refreshData();
              const msg = Amenity.is_active ? "archived" : "activated";
              this.$toast.success("Successfully  " + msg);
            })
            .catch((err) => {
              this.$toast.error("Amenity is not Archived");
            });
        } else {
        }
      });
    },
  },
  computed: {
    headers: function() {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.GetAmenitys();
    this.refreshData();
  },
};
</script>
